/**
 * Send-class detection for approval gating (impeccable /harden pass).
 *
 * An approval whose proposed tool actually SENDS (e.g. `email.send`, and any future
 * `*.send`) is irreversible — once the platform executes it the mail is gone. We want
 * an extra, lightweight confirm on those, while non-send approvals stay single-click.
 *
 * The approval wire contracts (ApprovalSummary/Detail, the chat approval item, the run
 * pending-approval summary) carry only the tool NAME. The definitive
 * `sideEffect: 'non_idempotent'` flag lives on the server-side `ToolDefinition`
 * (packages/shared `tool.ts`) and does NOT cross this boundary — there is no SEND /
 * ALWAYS_APPROVAL flag on the approval payload to key off. So we detect send-class by
 * name: exactly `email.send`, or any tool whose name ends in `.send`. If a definitive
 * send/side-effect flag is ever added to the approval payload, prefer it over this.
 */
export function isSendClassTool(tool: string | null | undefined): boolean {
  if (!tool) return false;
  return tool === 'email.send' || tool.endsWith('.send');
}
